import { axiosInstance } from '@libs/axios/axios';
import { apiCall } from '@shared/entity';

export type PendingReservation = {
  id: string;
  userId: string;
  serviceId: string;
  requestedDate: string;
  requestedDateTo: string;
  status: 'PENDING' | 'APPROVED' | 'DENIED';
  customerFirstName: string;
  customerLastName: string;
  customerPhone: string;
  customerPhonePrefix: string;
  customerEmail: string | null;
  note: string | null;
  createdAt: string;
  service: { serviceName: string; basePrice: string };
  photos?: { id: string; url: string }[];
};

export const getPendingReservations = (): Promise<PendingReservation[]> =>
  apiCall(
    () => axiosInstance.get('/api/public-reservations/pending'),
    'api.pendingReservations.fetchError',
  );

export const approveReservation = (id: string): Promise<PendingReservation> =>
  apiCall(
    () => axiosInstance.post(`/api/public-reservations/${encodeURIComponent(id)}/approve`),
    'api.pendingReservations.approveError',
  );

export const denyReservation = (id: string): Promise<PendingReservation> =>
  apiCall(
    () => axiosInstance.post(`/api/public-reservations/${encodeURIComponent(id)}/deny`),
    'api.pendingReservations.denyError',
  );
